import { ILoginData } from "./../interfaces/auth.interface";
import { LocalStorageKeys } from "../enum/enum";
import { ThemeType } from "../Themes/ThemeSelector";

export const getUserFromStorage = (): string | null => {
  return localStorage.getItem(LocalStorageKeys.USER);
};

export const clearLocalStorage = () => {
  localStorage.removeItem(LocalStorageKeys.USER);
};

export const addAuthToLocalStorage = (user: ILoginData) => {
  localStorage.setItem(LocalStorageKeys.USER, JSON.stringify(user));
};

// Dark mode is disabled for now: always report light, ignoring any stored preference.
// To re-enable, restore: localStorage.getItem(LocalStorageKeys.THEME) as ThemeType | null
export const getTheme = (): ThemeType | null => {
  return "light";
};

export const setTheme = (theme: ThemeType) => {
  localStorage.setItem(LocalStorageKeys.THEME, theme);
};

export const setAccount = (account: string) => {
  localStorage.setItem(LocalStorageKeys.ACCOUNT, account);
};

export const getAccount = (): string | null => {
  return localStorage.getItem(LocalStorageKeys.ACCOUNT);
};
